import React from 'react';
import { motion } from 'framer-motion';
import { ScrollReveal } from './ScrollReveal';
export const DualLaser = () => {
  const points = ['Le laser picoseconde génère des impulsions ultra-courtes, idéales pour fragmenter les encres résistantes', 'Le laser Q-Switched est très efficace pour les pigments noirs et foncés plus profonds', "La combinaison des deux permet d'adapter précisément chaque séance"];
  return <section id="dual-laser" className="py-32 md:py-56 bg-brand-dark" data-id="element-26">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12" data-id="element-27">
        <div className="max-w-5xl" data-id="element-28">
          <ScrollReveal blur scale duration={1.2} data-id="element-29">
            <h2 className="text-5xl md:text-7xl lg:text-[6.5rem] font-black text-brand-light mb-20 tracking-tighter leading-[1.02] text-balance" data-id="element-30">
              Pourquoi utiliser à la fois le laser picoseconde et le Q-Switched
              ?
            </h2>
          </ScrollReveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 mt-12 lg:mt-24" data-id="element-31">
          <div className="lg:col-span-5" data-id="element-32">
            <ScrollReveal delay={0.2} blur data-id="element-33">
              <p className="text-2xl md:text-3xl text-brand-gray font-light leading-relaxed" data-id="element-34">
                Cette complémentarité technologique garantit un traitement
                performant, sécurisé et conforme aux standards professionnels
                les plus récents.
              </p>
            </ScrollReveal>
          </div>

          <div className="lg:col-span-7" data-id="element-35">
            <div className="space-y-12" data-id="element-36">
              {points.map((point, index) => <div key={index} className="relative pt-10" data-id="element-37">
                  <motion.div initial={{
                scaleX: 0
              }} whileInView={{
                scaleX: 1
              }} viewport={{
                once: true,
                margin: '-100px'
              }} transition={{
                duration: 1,
                delay: 0.3 + index * 0.15,
                ease: [0.16, 1, 0.3, 1]
              }} className="absolute top-0 left-0 w-full h-[1px] bg-brand-border/50 origin-left" data-id="element-38" />
                  <ScrollReveal delay={0.4 + index * 0.15} blur direction="none" distance={0} data-id="element-39">
                    <div className="flex items-start space-x-8" data-id="element-40">
                      <span className="text-sm font-black text-brand-light/20 mt-1.5 tracking-widest" data-id="element-41">
                        0{index + 1}
                      </span>
                      <p className="text-xl md:text-2xl text-brand-light font-medium tracking-tight leading-snug" data-id="element-42">
                        {point}
                      </p>
                    </div>
                  </ScrollReveal>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
};